import { render, staticRenderFns } from "./notification-icon.vue?vue&type=template&id=656f0cd2&scoped=true"
import script from "./notification-icon.vue?vue&type=script&lang=js"
export * from "./notification-icon.vue?vue&type=script&lang=js"
import style0 from "./notification-icon.vue?vue&type=style&index=0&id=656f0cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f0cd2",
  null
  
)

export default component.exports